export function getAuthorModal(authorID) {
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=get_author_modal",
        datatype: "json",
        data: {"ajax_call_author_id": authorID},
        success: function (output) {
            var data = $.parseJSON(output);
            $("body").append(data);
            var modal = $('#author_profile_modal_' + authorID);
            modal.modal("show");
        }
    });
}